<template>
    <div class="container">
  
      <div class="nav-top">
            <div class="nav-left" @click="back()">
              <img src="../../assets/img/返回箭头.png" class="nav-img" />
              <span class="nav-lable"></span>
            </div>
            <div class="nav-middle" @click="search_uid()">语音</div>
            <div class="nav-right">
              <span class="nav-lable"></span>
              <img src="../../assets/img/返回箭头.png" class="nav-img none" />
            </div>
      </div>
  
      <ul class="list">
        <div class="search-block ub">
            <div class="btn-jump front" @click="jump(1)">前一天</div>
            <input class="time" type="text" readonly="readonly" v-model="dtm">
            <div class="btn-jump after" @click="jump(-1)">后一天</div>
            <input class="ub ub-f1" type="text" v-model="uid" placeholder="uid:">
        </div>

       <li class="item ub ub-ver" v-for="(item, index) in arr_voice" :key="index">
        <div class="msg-state ub ub-ac2 ub-pc">
            <span class="suc" v-if="item.state == 'success'">{{ item.state }}</span>
            <span class="fail" v-if="item.state == 'fail'">{{ item.state }}</span>
            <span class="dtm">{{ item.dtm }}</span>
        </div>
        <div class="ub ub-pc">
            <div class="user-info ub ub-pc">
                <img class="photo" :src="item.photo" alt="">
                <div class="other ub ub-ver ub-ac1">
                    <span class="nick">{{ item.nick.length > 4 ? item.nick.substr(0,4) + '...' : item.nick }}<span class="sex">({{ item.sex }})</span></span>
                    <div class="coin-score ub ub-ver">
                        <span class="coin">豪气:<a>{{ item.coin_total }}</a>-<a>{{ item.coin }}</a></span>
                        <span class="score">魅力:<a>{{ item.score_total }}</a>-<a>{{ item.score }}</a></span>
                    </div>
                </div>
            </div>
            <span class="jt">--</span>
            <div class="user-info ub ub-pc">
                <img class="photo" :src="item.photo2" alt="">
                <div class="other ub ub-ver ub-ac1">
                    <span class="nick">{{ item.nick2.length > 4 ? item.nick2.substr(0,4) + '...' : item.nick2 }}<span class="sex">({{ item.sex2 }})</span></span>
                    <div class="coin-score ub ub-ver">
                        <span class="coin">豪气:<a>{{ item.coin_total2 }}</a>-<a>{{ item.coin2 }}</a></span>
                        <span class="score">魅力:<a>{{ item.score_total2 }}</a>-<a>{{ item.score2 }}</a></span>
                    </div>
                </div>
            </div>
        </div>
  
        <div class="voice-block ub ub-ac2 ub-pc">
            <div class="ub ub-pc ub-f1">
                <div class="voice ub ub-pc" @click="play_voice(item)">
                    <img v-if="!(item.txt.serverId == msg_voice_cur.txt.serverId && voice_play_state == 1)" src="../../assets/img/new2024/audio.png" alt="">
                    <img v-if="(item.txt.serverId == msg_voice_cur.txt.serverId && voice_play_state == 1)" src="../../assets/img/new2024/audioPlay.gif" alt="">
                    <span>{{ item.txt.time }}''</span>
                </div>
                <div class="loading" v-if="(item.txt.serverId == msg_voice_cur.txt.serverId && voice_play_state == 3)">
                    <img src="../../assets/img/new2024/loading.gif" alt="">
                </div>
                <span class="coin">金币:{{ item.txt.coin }}</span>
            </div>
            <span class="played" v-if="item.played">已播放</span>
        </div>
       </li>
      </ul>
      <div class="ub ub-pc ub-ac"  v-if="arr_voice.length > 0">
        <div class="ub ub-ac ub-pc btn" @click="load_more()"><span>加载更多</span></div>
        </div>
    </div>
  </template>
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from "vuex";
  export default {
  
    data() {
      return {
        arr_voice: [],
        arr_voice_res: [],
        voice_play_state:0, //0==未开始； 1==播放； 2==暂定； 3==下载；
        msg_voice_pre:  {
            "txt": {
                "localId": "",
                "serverId": "",
                "time": 1,
                "coin": 0
            },
        },
        msg_voice_cur: {
            "txt": {
                "localId": "",
                "serverId": "",
                "time": 1,
                "coin": 0
            },
        },
        serverIds: [
        
        ],
        uid: "",
        dtm: new Date().Format("yyyy-MM-dd"),
        last_dtm: ""
      };
    },
    mounted() {
      this.init_page();
      this.init_wx();
    },
    beforeRouteEnter(to, from, next) {
    next(vm=>{
        if (from.name !== "sys_set") {
            vm.$router.push({ name: "index" });
            return false;
        }
    })
    },
    methods: {
      ...mapMutations(["get", "post", "post2", "wxPlayVoice", "wxStopVoice", "WxConfig", "wxDownloadVoice", "wxStartRecord", "wxStopRecord", "wxUploadVoice", "wxTranslateVoice", "wxOnVoicePlayEnd", "wxPauseVoice"]), //引入方法
  
      back() {
        this.$router.go(-1); //返回上一层
      },
  
      init_page() {
        var uid = this.$store.state.uid;
        var sysdic = this.$store.state.sysdic;
        var xhc_admin_uids = sysdic.xhc_admin_uids;
        if(xhc_admin_uids.indexOf(uid) == -1){
            this.$router.push({ name: "index" });
            return false;
        }
        
        this.search("",this.dtm,"");
      },
      init_wx() {
        //重置state录音状态
        this.$store.commit('set_objVal', {"voice_state":0});
        this.WxConfig({url:window.location.href});
        this.reset_wx();
      },

      jump(num) {
        this.arr_voice = [];
        this.arr_voice_res = [];
        
        var dtm = this.formatTime(this.adjustDate(num));
        this.dtm = dtm;
        this.search(this.uid,dtm,"");
      },

      load_more() {
        this.search(this.uid,this.dtm,this.last_dtm);
      },

      search_uid() {
        this.arr_voice = [];
        this.arr_voice_res = [];

        this.search(this.uid, this.dtm, "");
      },

      search(search_uid, dtm, time) {
        if (dtm == "") {
            dtm = this.dtm;
        }

        this.loading("加载中...",5000);
        var self = this;
        self.get({
            url: "/Admin1/Get_Msg_Voice?uid=" + search_uid + "&dtm=" + dtm + "&time=" + time,
            success: function (data) {
                self.$loading.close();
                self.format_data(data);
            },
        });
      },
      
      format_data(data) {
        var item;
        for (var i = 0; i < data.length; i++) {
            item = data[i];
            if (item.type == "voice") {
                item.photo = this.$store.state.url + "/photo/" + item.photo;
                item.photo2 = this.$store.state.url + "/photo/" + item.photo2;
                item.txt = JSON.parse(item.txt);
                item.txt.localId = "";
                this.arr_voice.push(item);

                this.last_dtm = item.dtm;
            }
            if (item.type == "voice_res") {
                this.arr_voice_res.push(item);
            }
        }

        //已播放处理
        this.arr_voice.forEach(item => {
            if (this.arr_voice_res.find(item2 => item2.txt == item.txt.serverId)) {
                item.played = true;
            }
        });

        //测试数据
        var test_len = this.serverIds.length;
        for (var j = 0; j < this.arr_voice.length; j++) {
            item = this.arr_voice[j];
            if (j < test_len) {
                item.txt.serverId = this.serverIds[j];
            }
        }
      },

      reset_wx(){
        //停止播放
        if(this.msg_voice_pre.txt.localId){
            this.wxStopVoice(this.msg_voice_pre.txt.localId);
        }
      },
        //播放语音
        play_voice(item) {
            //下载
            if(this.voice_play_state === 3){
                return false;
            }

            //更新当前消息
            this.msg_voice_pre = this.msg_voice_cur;
            this.msg_voice_cur = item;


            //第一种情况：首次播放，先下载
            if (item.txt.localId == ''){
                this.do_download_voice(item);
                return false;
            }

            //第二种情况：未播放
            if (this.voice_play_state === 0) {
                this.do_play_voice(item);
                return false;
            }

            //第三种情况：停止播放，开启下一条语音
            if (this.voice_play_state === 1) {
                if(this.msg_voice_pre.txt.localId == item.txt.localId){
                    this.do_stop_voice(item);
                    return false;
                }
                else{
                    this.do_stop_voice(this.msg_voice_pre);
                    this.do_play_voice(item);
                    return false;
                }
            }
        },
        //第一步下载
        do_download_voice(msg_item){
            this.voice_play_state = 3;
            //停止上一个语音
            if (this.msg_voice_pre.txt.localId !== "") {
                this.do_stop_voice(this.msg_voice_pre);
            }

            var server_id = msg_item.txt.serverId;
            var self = this;
            var data = {
                    serverId: server_id,
                    suc: function(res) {
                    //更换为下载后的localId
                    msg_item.txt.localId = res; 
                    
                    self.voice_play_state = 0;
                    self.play_voice(msg_item);
                    }
            }
            this.wxDownloadVoice(data);
        },
        //第二步播放
        do_play_voice(item){
            this.voice_play_state = 1;
            this.$store.commit('set_objVal', {"voice_state":2});
            this.wxPlayVoice(item.txt.localId);
            this.is_playVoice_end(item);
            },
            //监听语音是否播放完毕
            is_playVoice_end(item) {
            var self = this;
            var data = {
                suc: function(res) {
                    if (res) {
                        //self.$toast.center("监听到语音播放结束~");
                        self.voice_play_state = 0;
                        self.$store.commit('set_objVal', {"voice_state":0});
                    }
                }
            }
            this.wxOnVoicePlayEnd(data);
        },
        //停止播放
        do_stop_voice(item) {
            this.voice_play_state = 0;
            this.$store.commit('set_objVal', {"voice_state":0});
            this.wxStopVoice(item.txt.localId);
        },

        loading(title,time) {
            var self = this;
            this.$loading(title);
            setTimeout(() => {
                self.$loading.close();
            }, time);
        },

        
      adjustDate(num) {
        var date = new Date();
        if (this.dtm !== "") {
            date = new Date(this.dtm);
        }
        date.setDate(date.getDate() - num);
        return date;
      },

      formatTime(date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        var day = date.getDate();
        day = day < 10 ? '0' + day : day;
        return year + '-' + month + '-' + day;
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background-color: #EFEFEF;
  }
  .list {
    padding: 0.5rem 0;
  }

  .search-block {
    margin: 0.5rem 0;
    height: 2rem;
    .btn-jump {
        padding: 0.5rem 0.5rem;
        
        font-size: 0.75rem;
        color: #fff;
    }
    .front {
        background-color: forestgreen;
    }
    input {
        margin: 0 0.5rem;
    }
    .time {
        margin: 0 0.1rem;
        width: 4rem;
        border: 1px solid rgb(146, 146, 228);
    }
    .after {
        background-color: orange;
    }
  }

  .item {
    padding: 0.5rem;
    margin-bottom: 1rem;
    background-color: #fff;
    border-radius: 0.5rem;
    .msg-state {
        padding-bottom: 0.5rem;
        border-bottom: 1px dotted #888;
        .suc {
            font-size: 0.9rem;
            color: #04f82d;
        }
        .fail {
            font-size: 0.9rem;
            color: red;
        }
        .dtm {
            font-size: 0.9rem;
            color: #333;
        }
    }
    .user-info {
        .photo {
          margin-top: 0.5rem;
          width: 2.8rem;
          height: 2.8rem;
          border-radius: 50%;
        }
        .other {
            margin-left: 0.5rem;
            .nick {
                font-size: 0.9rem;
                color: #333;
                .sex {
                    margin-left: 0.2rem;
                }
            }
            .coin-score {
                font-size: 0.6rem;
                color: #333;
                a {
                    color: blue;
                }
            }
        }
    }
    .jt {
        margin: 0 0.5rem;
    }
    .voice-block {
        margin-top: 0.5rem;
        .voice {
            padding: 0 0.3rem;
            width: 10rem;
            height: 2rem;
            background-color: #9ae6e2;
            border-radius: 0.2rem;
            img {
                width: 1rem;
                height: 1rem;
            }
            span {
                margin-left: 0.3rem;
            }
        }
        .coin {
            margin-left: 0.5rem;
            font-size: 0.75rem;
            color: #333;
        }
        .loading {
            margin-left: 0.3rem;
            img {
                width: 1rem;
            }
        }
        .played {
            font-size: 0.75rem;
            color: #ba61ff;
        }
    }
  }

  .btn {
    margin: 1rem 0;
    padding: 0.5rem 8rem;
    border-radius: 2rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
    span {
      font-size: 0.9rem;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

  </style>
  